import React from 'react';
import { Container } from '@plone/components';
import Image from '@plone/volto/components/theme/Image/Image';
import ContactInfo from '@ifpb/portal/components/ContactInfo/ContactInfo';
import SocialNetworks from '@plonegovbr/volto-social-media/components/SocialNetworks/SocialNetworks';
import type { Person } from '@ifpb/portal/types/content';

interface PersonViewProps {
  content: Person;
}

const PersonView: React.FC<PersonViewProps> = ({ content }) => {
  const { title, description, image, social_links, text } = content;

  return (
    <Container id="page-document" className={`view-wrapper person-view`}>
      <Container className="info" narrow>
        <Container className="cabecalho">
          <Container className="person-info">
            <h1 className="documentFirstHeading">{title}</h1>
            <p className="description">{description}</p>
            <ContactInfo content={content} />
            {social_links && <SocialNetworks networks={social_links} />}
          </Container>
          {image && (
            <Container className={'image-wrapper'}>
              <Image item={content} imageField={'image'} />
            </Container>
          )}
        </Container>
        {text && (
          <Container className="body">
            <p dangerouslySetInnerHTML={{ __html: text?.data }} />
          </Container>
        )}
      </Container>
    </Container>
  );
};

export default PersonView;
